import { render, staticRenderFns } from "./editQuestion.vue?vue&type=template&id=1b71cff0&scoped=true&"
import script from "./editQuestion.vue?vue&type=script&lang=ts&"
export * from "./editQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./editQuestion.vue?vue&type=style&index=0&id=1b71cff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b71cff0",
  null
  
)

export default component.exports